import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import store from '@/store'

export async function getKpiGroup (filter) {
  const user = store.getters.getUser
  let url = '/kpigroup' + '?annonceur=' + user.advertiser
  if (filter.metrique !== null) {
    url = url + '&metrique=' + filter.metrique
  }
  if (filter.date_debut !== null) {
    url = url + '&date_debut=' + filter.date_debut
  }
  if (filter.date_fin !== null) {
    url = url + '&date_fin=' + filter.date_fin
  }
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return response.data
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export function getSocialInteractionsAggregated (query = {}) {
  const params = new URLSearchParams()
  if (query.startDate) params.set('startDate', query.startDate)
  if (query.endDate) params.set('endDate', query.endDate)
  const qs = params.toString()
  const url = '/kpi/sm/growing-interactions-aggregated' + (qs ? '?' + qs : '')
  return HTTP_HYPER_ESPACE_BACKEND.get(url)
}

export function getAdLifetimeKpi () {
  return HTTP_HYPER_ESPACE_BACKEND.get('/kpi/ad/lifetime')
}
